import React from 'react'
import { useTranslation } from 'react-i18next'
import GenericStatsDetails from './GenericStatsDetails'

const Vehicles: React.FC = () => {
  const { t } = useTranslation()

  return <GenericStatsDetails entity='vehicle' entityTranslation={t('global.stats.vehicles')} icon='car' />
}

export default Vehicles
